import api from './api';

export const fetchBonusSummary = async (params = {}) => {
  const response = await api.get('/admin/wallet/bonus/summary/', { params });
  return response.data;
};

export const fetchBonusLedgers = async (params = {}) => {
  const response = await api.get('/admin/wallet/bonus/ledger/', { params });
  return response.data;
};

export const fetchBonusSettings = async () => {
  const response = await api.get('/admin/wallet/bonus/settings/');
  return response.data;
};

export const updateBonusSettings = async (data) => {
  const response = await api.put('/admin/wallet/bonus/settings/', data);
  return response.data;
};

export const grantBonus = async (data) => {
  const response = await api.post('/admin/wallet/bonus/grant/', data);
  return response.data;
};

export const reverseBonus = async (data) => {
  const response = await api.post('/admin/wallet/bonus/reverse/', data);
  return response.data;
};

export const fetchBonusCampaignTemplates = async () => {
  const response = await api.get('/admin/wallet/bonus/campaign-templates/');
  return response.data;
};

export const fetchBonusCampaigns = async (params = {}) => {
  const response = await api.get('/admin/wallet/bonus/campaigns/', { params });
  return response.data;
};

export const createBonusCampaign = async (data) => {
  const response = await api.post('/admin/wallet/bonus/campaigns/', data);
  return response.data;
};

export const previewBonusCampaign = async (data) => {
  const response = await api.post('/admin/wallet/bonus/campaigns/preview/', data);
  return response.data;
};

export const runBonusCampaign = async (campaignId) => {
  const response = await api.post(`/admin/wallet/bonus/campaigns/${campaignId}/run/`);
  return response.data;
};

export const fetchBonusCampaignRecipients = async (campaignId) => {
  const response = await api.get(`/admin/wallet/bonus/campaigns/${campaignId}/recipients/`);
  return response.data;
};
